// Constants
import { ONE_HUNDRED } from './constants/layout-operational.utils.constants';
// Types
import { LayoutOperationalType } from '../types/layout-operational.type';

const getProgressBarPercentage = ({
  currentStep,
  maxSteps,
}: Pick<LayoutOperationalType, 'currentStep' | 'maxSteps'>): number =>
  (currentStep / maxSteps) * ONE_HUNDRED;

export { getProgressBarPercentage };
